import React from 'react'
import CommonHeader from '../../../navbars/CommonHeader';
import BrandLogo from '../../../navbars/BrandLogo';

// Header for a single notes video: the shared CommonHeader (its own colour),
// with the back arrow returning to the notes videos list.
function VideoNavbar() {
    return (
        <CommonHeader
            color="auto"
            tone="light"
            back="/student/notes/videos"
            backLabel=""
            left={(
                <div className="my-2 my-md-0 mr-md-5 mx-auto">
                    <BrandLogo fill="#ffffff" width="159.501" />
                </div>
            )}
        />
    );
}

export default VideoNavbar;
